<div
  class="soft-card rounded-[6px] flex w-full abteilungs-center items-center justify-between relative cursor-pointer"
  [ngClass]="
    mode === 'selection' && selected
      ? ' border-solid border-2 border-primary'
      : 'border-solid border-2 border-transparent'
  "
  (click)="tapped.emit()"
>
  <div
    class="w-full flex items-center gap-2 z-10"
    [class]="grid() ? 'flex-col items-center text-center' : 'flex-row items-center'"
  >
    @if (abteilungStatusDasharrayData()?.total) {
      @if (abteilungStatusDasharrayData(); as dasharrayData) {
        <soft-donut-chart
          [size]="grid() ? 'w-25 h-25' : 'w-14 h-14'"
          [showTotal]="true"
          [segments]="[
            {
              label: '#PMS_STATUSABFRAGE.ABTEILUNGEN.PERSONEN_ANWESEND',
              value: dasharrayData.anwesend?.number || 0,
              color: 'var(--colorSuccess500)',
            },
            {
              label: '#PMS_STATUSABFRAGE.ABTEILUNGEN.PERSONEN_ABWESEND_ROT',
              value: dasharrayData.abwesendRot?.number || 0,
              color: 'var(--colorDanger500)',
            },
            {
              label: '#PMS_STATUSABFRAGE.ABTEILUNGEN.PERSONEN_ABWESEND_GELB',
              value: dasharrayData.abwesendGelb?.number || 0,
              color: 'var(--colorWarning500)',
            },
          ]"
        ></soft-donut-chart>
      }
    } @else {
      <div
        class="flex items-center justify-center"
        [class]="grid() ? 'h-25 w-25' : 'h-14 w-14'"
      >
        <soft-ds-loading-spinner size="lg" />
      </div>
    }

    <div
      class="flex grow w-100 m-0"
      [class]="
        grid() ? 'items-center text-center justify-center mt-2' : 'items-start pl-2'
      "
    >
      <div class="flex flex-col abteilungs-start pb-1.5">
        <div class="mt-1.5 font-semibold">{{ abteilung().abteilung.bezeichnung }}</div>
        <div class="mt-1.5 text-sm text-light">
          {{ abteilung().status?.anwesend || 0 }} von
          {{ abteilungStatusDasharrayData()?.total || 0 }}
          {{ '#PMS_STATUSABFRAGE.ABTEILUNGEN.PERSONEN_ANWESEND' | translate }}
        </div>
      </div>
    </div>
  </div>

  @if (mode === 'display' && !grid()) {
    <div class="flex items-center gap-2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 20 20"
        stroke-width="1.5"
        stroke="currentColor"
        class="w-5 h-5 opacity-25"
      >
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          d="M8.25 4.5l7.5 7.5-7.5 7.5"
        />
      </svg>
    </div>
  }

  @if (mode === 'selection' && selected) {
    <div
      class="bg-surface rounded-full border-solid border-primary border-2 p-1 z-10 flex items-center justify-center"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        stroke-width="2.5"
        stroke="currentColor"
        class="w-5 h-5 text-primary"
      >
        <path stroke-linecap="round" stroke-linejoin="round" d="M4.5 12.75l6 6 9-13.5" />
      </svg>
    </div>
  }
</div>
